import { render } from "./SyndicatedStoryEditorComponent.vue.js?vue&type=template&id=97b64e58&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditorComponent.vue?vue&type=template&id=97b64e58&scoped=true"
import script from "./SyndicatedStoryEditorComponent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditorComponent.vue?vue&type=script&lang=js"
export * from "./SyndicatedStoryEditorComponent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditorComponent.vue?vue&type=script&lang=js"

import "./SyndicatedStoryEditorComponent.vue.scss?vue&type=style&index=0&id=97b64e58&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditorComponent.vue?vue&type=style&index=0&id=97b64e58&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b64e58"],['__file',"src/Web/scripts/components/publication/SyndicatedStoryEditorComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97b64e58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97b64e58', __exports__)) {
    api.reload('97b64e58', __exports__)
  }
  
  module.hot.accept("./SyndicatedStoryEditorComponent.vue.js?vue&type=template&id=97b64e58&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SyndicatedStoryEditorComponent.vue?vue&type=template&id=97b64e58&scoped=true", () => {
    api.rerender('97b64e58', render)
  })

}


export default __exports__